import type { TranslateFn } from '@/composables/TranslateFn'
import type { AppProblemModel } from '@/services/api/AppProblemModel'
import { resolveProblemMessage } from './resolveProblemMessage'
import { appendRequestReference } from './appendRequestReference'

/**
 * `resolveProblemMessage()` with a trailing support-reference suffix appended
 * when the problem carries a `requestId`, for sinks that show that reference
 * to the person reporting an issue.
 */
export const resolveProblemMessageWithReference = (
  problem: AppProblemModel,
  t: TranslateFn,
  fallback?: string
): string => appendRequestReference(resolveProblemMessage(problem, t, fallback), problem)
